import { SuppressedDefaultActionLink } from "@snapchat/web-core-ui";
import { getClassName } from "@snapchat/web-sds-c";
import clsx from "clsx";
import styles from "./TabBanner.module.css";
function getLinkedTab(urlLink, isSelected, tabLabel, index, logLinkClick) {
    return (<div className={clsx(styles.unselectedTab, {
            [styles.selectedTab]: isSelected,
        })} data-testid={`tabBannerTabLink_${index}`} key={`linkedTab-${index}`}>
      <span className={clsx(styles.unselectedSpan, {
            [styles.selectedSpan]: isSelected,
        })}>
        <span className={styles.link}>
          <SuppressedDefaultActionLink link={urlLink} logMetric={logLinkClick}>
            <span className={getClassName("H7", true)}>{tabLabel}</span>
          </SuppressedDefaultActionLink>
        </span>
      </span>
    </div>);
}
function getTab(isSelected, tabLabel, index) {
    return (<div className={clsx(styles.unselectedTab, {
            [styles.selectedTab]: isSelected,
        })} key={`tab-${index}`}>
      <span className={getClassName("H7", true)} data-testid={`tabBannerTab_${index}`}>
        {tabLabel}
      </span>
    </div>);
}
export function TabBanner(props) {
    return (<div className={styles.bannerContainer}>
      {props.tabItems.map((tabItem) => tabItem.link && tabItem.link !== ""
            ? getLinkedTab(tabItem.link, tabItem.isSelected, tabItem.label, tabItem.index, tabItem.logLinkClick)
            : getTab(tabItem.isSelected, tabItem.label, tabItem.index))}
    </div>);
}
